import template from "./template_crud";
const archive = '/archive'
export const canArchiveProject = template.getProjectId(archive+'/can')
export const setArchiveProject = template.postProjectId(archive)
export const isArchiveProject = template.getProjectId(archive)